module.exports = __webpack_public_path__ + "img/Use for Templates popup.a6ee2e2.png";